/**
 * Returns the Aruba states list to populate the select item.
 */
export function gluky_addressfield_ar_states_list() {
  let temporalStates = [];
  const states =
  {
    '00': 'Noord',
    '01': 'Oranjestad',
    '02': 'Paradera',
    '03': 'San Nicolas',
    '04': 'Santa Cruz',
    '05': 'Savaneta'
  }

  Object.keys(states).map((res) => {
    temporalStates = [
      ...temporalStates,
      {
        name: states[res],
        code: res,
      },
    ];
  });
  return temporalStates;
}

/**
 * Returns the Aruba cities list by state code to populate the select item.
 *
 * @param $state_code
 *   The DANE state code
 * @return
 */
export function gluky_addressfield_ar_cities_list($state_code) {
  let temporalCities = [];
  const $data = {
    '00': {
      '0001': 'Alto Vista',
      '0002': 'Moko',
      '0003': 'Palm Beach',
      '0004': 'Palm Beach, Papilon',
      '0005': 'Washington',
    },
    '01': {
      '0101': 'Oranjestad',
      '0102': 'Tanki Leendert, Centro di Barrio Tanki Lendert',
    },
    '02': {
      '0201': 'Ayo',
      '0202': 'Paradera',
      '0203': 'Paradera, Piedra Plat',
      '0204': 'Paradera, Shiribana',
    },
    '03': {
      '0301': 'Sint Nicolas'
    },
    '04': {
      '0401': 'Balashi',
      '0402': 'Cashero',
      '0403': 'Hooiberg',
      '0404': 'Macuarima',
      '0405': 'Urataca',
    },
    '05': {
      '0501': 'Cura Cabai',
      '0502': 'G.M. de Bruynewijk',
      '0503': 'Pos Chiquito',
      '0504': 'Seroe Alejandro',
    }
  }
  const cities = $data[$state_code] ? $data[$state_code] : null;
  Object.keys(cities).map((citie) => {
    temporalCities = [
      ...temporalCities,
      {
        name: cities[citie],
        code: citie,
      },
    ];
  });
  return temporalCities;
}

